import React from "react";
import { motion } from "framer-motion";
import { IMAGES, HOME } from "@/content";

// Abstract "one connected system" motif using the generated diagram + animated nodes.
export function ConnectedSystem() {
  return (
    <div className="relative grid md:grid-cols-2 gap-12 items-center">
      <div className="relative">
        <div className="absolute inset-0 bg-electric/10 blur-3xl rounded-full" />
        <motion.img
          src={IMAGES.connectedSystem}
          alt="Abstract diagram of the body as one connected system"
          className="relative rounded-3xl w-full object-cover border border-white/10"
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.25, 1, 0.5, 1] }}
          loading="lazy"
        />
      </div>
      <div>
        <span className="label">One connected system</span>
        <h3 className="font-display text-3xl sm:text-4xl font-bold text-white mt-4 leading-tight">
          The body trained the way it is actually built to work.
        </h3>
        <p className="text-ice/70 mt-5 leading-relaxed">
          The human body is an intelligent, layered system designed to move, sense and adapt, yet so many elements are neglected in current fitness programs.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          {HOME.concepts.map((c, i) => (
            <motion.span key={c}
              initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.07, duration: 0.5 }}
              className="rounded-full border border-electric/30 bg-electric/5 px-4 py-2 text-sm text-ice/90">
              {c}
            </motion.span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ConnectedSystem;
